






























import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'UMN_SandboxQ5',
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        regionA: null,
        regionB: null,
      },
    };
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/UMNsandboxQ5.png');
    },
  },
});
